// extracted by mini-css-extract-plugin
export var button = "_f0-4";
export var hasDarkBackground = "_f0-7";
export var hasLightBackground = "_f0-6";
export var iconWrapper = "_f0-0";
export var large = "_f0-2";
export var medium = "_f0-1";
export var small = "_f0-5";
export var xsmall = "_f0-3";